__turbopack_context__.v({
  "SHideOnDesktop": "t5jk2q_SHideOnDesktop",
  "SHideOnMobile": "t5jk2q_SHideOnMobile",
  "SWatchlistSvg": "t5jk2q_SWatchlistSvg",
  "SWatchlistSvg_gradient": "t5jk2q_SWatchlistSvg_gradient",
  "SWithWatchList": "t5jk2q_SWithWatchList",
  "SWithWatchlistButton": "t5jk2q_SWithWatchlistButton",
  "ThemeDk": "t5jk2q_ThemeDk",
  "ThemeFw": "t5jk2q_ThemeFw",
});
